//export const API_URL = "http://192.168.1.34:1337";
//export const API_URL = "https://associacio-amics-jardi-botanic.herokuapp.com";
export const API_URL = "https://backoffice.aajbb.cat/";

